var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "26px",
    viewBox: "0 0 33 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.5 Otro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.9Reservaciones-Copy-2",
    transform: "translate(-85.000000, -1053.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(68.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-11",
    transform: "translate(0.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5-Otro",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.478 L0,2.748 C0,1.23 1.23,0 2.748,0 L28.183,0 C29.7,0 30.93,1.23 30.93,2.748 L30.93,20.478 C30.93,21.995 29.7,23.226 28.183,23.226 L2.748,23.226 C1.23,23.226 0,21.995 0,20.478 Z",
    id: "Stroke-1",
    stroke: "#FE8D27",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2572,11.6129 C11.0152,11.8979 12.0972,12.6659 13.1522,13.7209 C14.2072,14.7759 14.9752,15.8579 15.2602,16.6159 C15.5452,15.8579 16.3142,14.7759 17.3682,13.7209 C18.4232,12.6659 19.5052,11.8979 20.2632,11.6129 C19.5052,11.3279 18.4232,10.5599 17.3682,9.5049 C16.3142,8.4499 15.5452,7.3679 15.2602,6.6099 C14.9752,7.3679 14.2072,8.4499 13.1522,9.5049 C12.0972,10.5599 11.0152,11.3279 10.2572,11.6129",
    id: "Fill-3",
    fill: "#FE8D27"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtro);
export default __webpack_public_path__ + "static/media/Otro.9bb52f1a41df2819d8b6fda8dadb6d91.svg";
export { ForwardRef as ReactComponent };